import React, { useState } from 'react';
import { Link } from 'gatsby';
import style from './footer.module.css';
import { makeRequest } from '../api';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [registeredMessage, setRegisteredMessage] = useState('');

  function changeEmail(evt) {
    setEmail(evt.target.value);
  }

  function validateEmail(e) {
    const reg =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return reg.test(e.toLowerCase());
  }

  function submitNewsletter() {
    if (!validateEmail(email)) {
      setRegisteredMessage('Enter a valid email.');
    } else {
      makeRequest(
        'POST',
        'web/emailsubscribe',
        { email },
        response => {
          setRegisteredMessage(response);
          setEmail('');
        },
        () => {
          setRegisteredMessage('An error occured.');
        },
      );
    }
  }
  const getApp = appStore => {
    const contentType = appStore ? 'AppStore' : 'PlayStore';
    if (typeof window !== 'undefined') {
      if (window.fbq) {
        window.fbq('track', 'ViewContent', { content_name: contentType });
      }
      if (window.gtag) {
        window.gtag('event', 'select_content', { content_type: contentType });
      }
    }
    if (appStore) {
      setTimeout(() => {
        window.location.href =
          'https://apps.apple.com/se/app/ohcleo/id1538135901?l=en';
      }, 500);
    } else {
      // PlayStore stuff
      setTimeout(() => {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.ohcleo.android';
      }, 500);
    }
  };

  return (
    <footer>
      <div className={style.footerContent}>
        <div className={style.left}>
          <Link to="/">
            <img src="/images/OhCleo__White.svg" alt="Oh Cleo logo" />
          </Link>
          <h4 className={style.newsletter}>Join our newsletter</h4>
          <p className={`${style.newsletter} bodytext-1`}>
            Subscribe for updates & new features.
          </p>
          <div className={style.newsletterContainer}>
            <div className={style.newsletterInput}>
              <input
                placeholder="Enter your email..."
                className="bodytext-1"
                value={email}
                type="email"
                onChange={evt => changeEmail(evt)}
                onKeyUp={() => setRegisteredMessage('')}
              />
              <button type="button" onClick={() => submitNewsletter()}>
                <img src="/images/arrow.svg" alt="arrow" />
              </button>
            </div>
            {registeredMessage && (
              <p className={`${style.newsletter} bodytext-1`}>
                {registeredMessage}
              </p>
            )}
          </div>
          <div className={style.countrySection}>
            <img src="/images/swedenLogo.svg" alt="Country-Sweden" />{' '}
            <p className="bodytext-2">SWEDEN</p>
          </div>
        </div>
        <div className={style.right}>
          <div className={style.contentRight}>
            <div className={style.contentRightColumn}>
              <p>SOCIAL</p>
              <a href="https://www.instagram.com/ohcleo/">Instagram</a>
              <a href="https://www.facebook.com/OhCleoApp/">Facebook</a>
            </div>
            <div className={style.contentRightColumn}>
              <p>APPS</p>
              <a onClick={() => getApp(true)}>
                <img src="/images/apple.svg" alt="Apple iOS" />
                Apple iOS
              </a>
              <a onClick={() => getApp(false)}>
              <span><img src="/images/android.svg" alt="Android" />
               Android</span>
              </a>
            </div>
            <div className={style.contentRightColumn}>
              <p>OHCLEO</p>
              <Link to="/press">For Press</Link>
              <Link to="/what-is-audio-erotica">What is Audio Erotica?</Link>
              {/* <a href="/">Affiliates</a>
              <a href="/">Blog</a> */}
              <Link to="/become-content-creator">Apply as Creator</Link>
            </div>
          </div>
        </div>
      </div>
      <div className={style.line} />
      <div className={style.footerContent}>
        <div className={style.left}>
          <p className={`${style.copyright} bodytext-2`}>
            &copy; OhCleo AB {new Date().getFullYear()}
          </p>
        </div>
        <div className={style.right}>
          <div className={style.bottomHolder}>
            <p className="bodytext-2"><Link to="/pp">Privacy Policy</Link></p>
            <p className="bodytext-2"><Link to="/tos">Terms of Service</Link></p>
            {/* <p className="bodytext-2">Cookie Policy</p> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
